export const FEATURED_THERAPISTS_LIMIT = 5
